/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_SpeedInputs */

const en_playbar_speed = /** @type {(inputs: Playbar_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playback Speed`)
};

const es_playbar_speed = /** @type {(inputs: Playbar_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de reproducción`)
};

/**
* | output |
* | --- |
* | "Playback Speed" |
*
* @param {Playbar_SpeedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_speed = /** @type {((inputs?: Playbar_SpeedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_SpeedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_speed(inputs)
	return en_playbar_speed(inputs)
});